import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getDomainConfig } from "../../config/config";
import { Checkbox } from "../Input/Input";
import StandardButton from "../UI/StandardButton";
import StandardFieldset from "../UI/StandardFieldset";
import StandardModal from "../UI/StandardModal";

import { logModalAction } from "../Analytics/Universal/PageView/datalayer.functions";
import { BookingSiteOperated } from "../BookingSiteOparatedByComponent/BookingSiteOperatedBy";
import ATDTermsAndPrivacy from "../TermsAndPrivacy/ATDTermsAndPrivacy";
import StandardTextParser from '../TermsAndPrivacy/StandardTextParser';
import { googleDataLayer } from "../Analytics/Universal/PageView/googleDataLayer";

const Terms = (props) => {

  const config = getDomainConfig();

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [checked, setChecked] = useState(false);

  const { t } = useTranslation('common');

  const handleTermsClick = (e) => {
    e.preventDefault();
    setModalTitle(t("booking-conditions"));
    setModalContent(config.termsLink);
    setShowModal(!showModal);
  };

  const handlePrivacyClick = (e) => {
    e.preventDefault();
    setModalTitle(t("privacy-policy"));
    setModalContent(config.policyLink);
    setShowModal(!showModal);
  };

  const handleCloseModal = (e) => {
    e.preventDefault();
    if(config.siteName === "Universal Bookings"){
      logModalAction('Modal Close','Checkout',modalContent)
    }
    setShowModal(false);
  };

  const isChecked = (isChecked) => {
    googleDataLayer.createCheckboxClickEvent('agreeTermsClick', !checked)
    setChecked(!checked)
    if(!isChecked) {
      props.setValue('terms', true, { shouldValidate: true })
    } else {
      props.resetField('terms', { keepTouched: false, keepDirty: false })

    if (props.isFormSubmitted && isChecked) {
      props.setError("terms", {type: "custom"})
    }
    }
  };

  return (
    <StandardFieldset className="termsFieldset" id="terms-pane">
        <Checkbox
          register={props.register}
          errors={props.errors}
          name={"terms"}
          onChange={() => isChecked(checked)}
          onBlur={(e) => e.preventDefault()} // Prevent validation from triggering onBlur
          required={true}
          checked={checked}
          label={
            <React.Fragment>
              {t('i-agree-with-the')}{" "}
              <a href="#modal" onClick={handleTermsClick}>
                {t('booking-conditions')}
              </a>{" "}
              {t('and')}{" "}
              {t('the')}{" "}
              <a href="#modal" onClick={handlePrivacyClick}>
              {t('privacy-policy')}
              </a>
            </React.Fragment>
          }
          errorText={t('please-accept-the-terms-and-conditions')}
          touched={props.touchedFields["terms"]}
      />

      {showModal && (
        <StandardModal titleText={modalTitle} id="modal">
          {config.brand === "Atd" && <ATDTermsAndPrivacy nodeId={modalContent}/>}
          {config.brand !== "Atd" && (config.siteName === "Universal Bookings" || "SeaWorld Parks UK" ? <StandardTextParser standardTextLink={modalContent} /> : <iframe id="myFrame" title="Terms and conditions" src={modalContent}></iframe>)}
          <StandardButton
            className="modalClose"
            aria-label="Close modal"
            id="modal-close"
            onClick={handleCloseModal}
          >
           <span>{t('close')}</span>
          </StandardButton>
        </StandardModal>
      )}
      {config.brand === 'Uo' ? <BookingSiteOperated/> : ''}
    </StandardFieldset>
  );
};

export default Terms;
